import React, { useContext } from 'react';
import { baseURL } from '../../../../api';
import AwesomeSlider from 'react-awesome-slider';
import WithAutoplay from 'react-awesome-slider/dist/autoplay';
import ReactMarkdown from 'react-markdown';
import 'react-awesome-slider/src/styles';
import './NewsSlider.scss';

// Context
import MainContext from '../../../../contexts/pages/main/mainContext';

const AutoplaySlider = WithAutoplay(AwesomeSlider);

const IntraNews = ({ className }) => {
    const mainContext = useContext(MainContext);
    const { intraNews: news } = mainContext;

    if (!news || news.length === 0) return null;

    return (
        <div className={`intraNews-wrapper ${className || ''}`}>
            <AutoplaySlider
                bullets={news.length > 1}
                organicArrows={news.length > 1}
                play={true}
                cancelOnInteraction={false}
                interval={6000}
                showTimer={false}
               // fillParent={true}
            >
                {news.map((item) => {
                    const imageUrl = item?.imagen?.formats?.large?.url || item?.imagen?.url;
                    const destinationLink = item.link || item.enlace || item.url;
                    const hasText = (item.titulo && item.titulo.trim() !== '') || 
                                    (item.contenido && item.contenido.trim() !== '' && item.contenido.trim() !== '.');

                    return (
                        <div
                            key={item._id || item.id}
                            className={`intraNews__slide ${destinationLink ? 'is-clickable' : ''}`}
                            data-src={imageUrl ? `${baseURL}${imageUrl}` : undefined}
                            onClick={destinationLink ? () => window.open(destinationLink, '_blank', 'noopener,noreferrer') : undefined}
                        >
                            {hasText && (
                                <div className="intraNews__overlay">
                                    <span className="intraNews__tag">#NOTICIAS BABEQUE</span>
                                    {item.titulo && <h3 className="intraNews__title">{item.titulo}</h3>}
                                    {item.contenido && item.contenido.trim() !== '.' && (
                                        <div className="intraNews__body">
                                            <ReactMarkdown>
                                                {item.contenido.length > 180 ? `${item.contenido.substring(0, 180)}...` : item.contenido}
                                            </ReactMarkdown>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </AutoplaySlider>
        </div>
    );
};

export default IntraNews;
